import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [linksOpen, setLinksOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setLinksOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header>
      <div className="container nav-container">
        <Link to="/" className="nav-name">andy siegel</Link>
        <div className="nav-right">
          <div className="nav-anchors">
            <a href="/#about" className="nav-anchor">[about]</a>
            <a href="/#projects" className="nav-anchor">[projects]</a>
            <a href="/#experience" className="nav-anchor">[experience]</a>
            <a href="/#blog" className="nav-anchor">[blog]</a>
          </div>
          <div className="nav-dropdown-wrap" ref={dropdownRef}>
            <button
              className="nav-links-btn"
              onClick={() => setLinksOpen((o) => !o)}
            >
              links {linksOpen ? "↑" : "↓"}
            </button>
            {linksOpen && (
              <div className="nav-dropdown">
                <a href="/Andy_Siegel_Resume.pdf" target="_blank" rel="noopener noreferrer">
                  <span className="drop-arrow">↗</span> resume
                </a>
                <a href="https://github.com/andyjsiegel" target="_blank" rel="noopener noreferrer">
                  <span className="drop-arrow">↗</span> github
                </a>
                <a href="https://www.linkedin.com/in/andyjsiegel" target="_blank" rel="noopener noreferrer">
                  <span className="drop-arrow">↗</span> linkedin
                </a>
                <a href="mailto:andyjsiegel1@gmail.com">
                  <span className="drop-arrow">↗</span> email
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
